import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../../services/reactQuery/reactQueryService";
import { Stack, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid";
import { WarningAmberOutlined } from "@mui/icons-material";
import { InquiryToCustomerStatus } from "../../../types/Entities/InquiryToCustomer";
import { MinimalCase } from "../../../types/Entities/MinimalCase";

type ActiveInquiryProps = {
  minimalCase: MinimalCase;
};

export default function CaseNeedsAttention({ minimalCase }: ActiveInquiryProps) {
  const inquiryFilters = {
    productId: minimalCase.id,
    "status[0]": InquiryToCustomerStatus.STATUS_OPEN,
    "status[1]": InquiryToCustomerStatus.STATUS_OVERDUE,
  };

  const inquiryApiUri = "/inquiry_to_customers";
  const { data: inquiries } = useQuery({
    queryKey: queryKeys.collection(inquiryApiUri, inquiryFilters),
    queryFn: () => fetchCollection(inquiryApiUri, inquiryFilters)
  });

  if (inquiries?.length > 0 || minimalCase.name === "pendingCase") {
    return (
      <Grid sx={{ flexGrow: 1 }}>
        <Stack direction={"row"} sx={{
          justifyContent: "flex-end"
        }}>
          <Tooltip
            title={inquiries?.length > 1 ? "In diesem Fall sind Rückmeldungen durch Sie nötig." : "In diesem Fall ist eine Rückmeldung durch Sie nötig."}
            placement={"right"}
          >
            <WarningAmberOutlined color={"primary"} />
          </Tooltip>
        </Stack>
      </Grid>
    );
  }

  return null;
}
